/**
 * Tambur ATC button micro-feedback
 * Sequence (Anders / Jeanerica clip): check → ring → rays outward → drawer.
 * Visual only — does not touch cart/DHL logic.
 */
(function () {
  /** Label returns after sequence (~25% faster than prior hold). */
  var HOLD_MS = 1380;
  /** Drawer starts sooner — while rays are finishing, not after full hold. */
  var DRAWER_DELAY_MS = 920;
  var timers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function burstSvg() {
    var rays = '';
    var i;
    for (i = 0; i < 12; i++) {
      rays +=
        '<g class="tambur-atc__ray-wrap" transform="rotate(' +
        i * 30 +
        ' 20 20)">' +
        '<line class="tambur-atc__ray" style="--i:' +
        i +
        '" x1="20" y1="7.5" x2="20" y2="3.5"/>' +
        '</g>';
    }
    return (
      '<svg class="tambur-atc__burst" width="28" height="28" viewBox="0 0 40 40" fill="none" aria-hidden="true" focusable="false">' +
      '<g class="tambur-atc__rays" transform="rotate(204 20 20)">' +
      rays +
      '</g>' +
      '<circle class="tambur-atc__ring" cx="20" cy="20" r="9.5"/>' +
      '<path class="tambur-atc__tick" d="M14.2 20.2l3.2 3.2 7.2-7.4"/>' +
      '</svg>'
    );
  }

  function ensureStructure(btn) {
    if (!btn || btn.nodeType !== 1) return null;
    if (!btn.hasAttribute('data-atc-feedback')) {
      btn.setAttribute('data-atc-feedback', '');
    }

    var label = btn.querySelector('[data-atc-label]');
    if (!label) {
      label = document.createElement('span');
      label.className = 'tambur-atc__label';
      label.setAttribute('data-atc-label', '');
      while (btn.firstChild) {
        label.appendChild(btn.firstChild);
      }
      if (!label.textContent.trim()) {
        label.textContent = btn.getAttribute('aria-label') || '';
      }
      btn.appendChild(label);
    } else if (!label.classList.contains('tambur-atc__label')) {
      label.classList.add('tambur-atc__label');
    }

    var done = btn.querySelector('[data-atc-done]');
    if (!done) {
      done = document.createElement('span');
      done.className = 'tambur-atc__done';
      done.setAttribute('data-atc-done', '');
      done.setAttribute('aria-hidden', 'true');
      done.innerHTML = burstSvg();
      btn.appendChild(done);
    } else if (!done.querySelector('.tambur-atc__burst') || !done.querySelector('.tambur-atc__ring')) {
      done.innerHTML = burstSvg();
    } else {
      /* Keep liquid/JS SVG in sync when viewBox/geometry changes */
      var burst = done.querySelector('.tambur-atc__burst');
      if (burst && burst.getAttribute('viewBox') !== '0 0 40 40') {
        done.innerHTML = burstSvg();
      }
    }

    var live = btn.querySelector('[data-atc-live]');
    if (!live) {
      live = document.createElement('span');
      live.className = 'tambur-atc__sr';
      live.setAttribute('data-atc-live', '');
      live.setAttribute('aria-live', 'polite');
      btn.appendChild(live);
    }

    return btn;
  }

  function clearTimer(btn) {
    if (!timers || !btn) return;
    var t = timers.get(btn);
    if (t) {
      clearTimeout(t);
      timers.delete(btn);
    }
  }

  function reset(btn) {
    if (!btn) return;
    clearTimer(btn);
    btn.classList.remove('is-pressing', 'is-adding', 'is-added');
    var live = btn.querySelector('[data-atc-live]');
    if (live) live.textContent = '';
    var burst = btn.querySelector('.tambur-atc__burst');
    if (burst) {
      var parent = burst.parentNode;
      var html = burst.outerHTML;
      burst.remove();
      if (parent) parent.insertAdjacentHTML('afterbegin', html);
    }
  }

  function setLabel(btn, text) {
    if (!btn) return;
    ensureStructure(btn);
    var label = btn.querySelector('[data-atc-label]');
    if (label) label.textContent = text;
    else btn.textContent = text;
  }

  function press(btn) {
    btn = ensureStructure(btn);
    if (!btn) return;
    clearTimer(btn);
    /* Start check immediately on click — no waiting for /cart/add or a dark fill. */
    btn.classList.remove('is-added');
    void btn.offsetWidth;
    btn.classList.add('is-pressing', 'is-adding', 'is-added');
  }

  function success(btn, opts) {
    btn = ensureStructure(btn);
    if (!btn) return;
    opts = opts || {};
    clearTimer(btn);
    btn.classList.remove('is-pressing');
    /* If press() already started the sequence, don't restart (avoids a flash). */
    if (!btn.classList.contains('is-added')) {
      btn.classList.remove('is-added');
      void btn.offsetWidth;
      btn.classList.add('is-adding', 'is-added');
    } else {
      btn.classList.add('is-adding');
    }

    var live = btn.querySelector('[data-atc-live]');
    if (live) {
      live.textContent = opts.announce || btn.getAttribute('data-atc-added-label') || 'Added';
    }

    var hold = typeof opts.holdMs === 'number' ? opts.holdMs : HOLD_MS;
    if (timers) {
      timers.set(
        btn,
        setTimeout(function () {
          reset(btn);
        }, hold)
      );
    } else {
      setTimeout(function () {
        reset(btn);
      }, hold);
    }
  }

  function fail(btn) {
    reset(btn);
  }

  function drawerDelayMs() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return 0;
      }
    } catch (e) { /* ignore */ }
    return DRAWER_DELAY_MS;
  }

  window.TamburAtcFeedback = {
    ensure: ensureStructure,
    setLabel: setLabel,
    press: press,
    success: success,
    fail: fail,
    reset: reset,
    drawerDelayMs: drawerDelayMs,
    DRAWER_DELAY_MS: DRAWER_DELAY_MS
  };
})();
